import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { AppDispatch } from "index";
import { Spinner, Alert, Card, Button, Row, Col } from "react-bootstrap";
import { Select, MenuItem } from "@mui/material";
import ArrowBack from "@mui/icons-material/ArrowBack";
import PageContainer from "Common/Components/PageContainer/PageContainer";
import { MecordColors } from "Constants/Color";
import { fetchProductEnquiryById } from "slices/enquiry/thunk";
import { EnquiryDataProps } from "pages/Enquiry/types";

// Modular View Components
import EnquiryViewComponent from "./EnquiryDetails";
import LoadingSpinner from "components/LoadingSpinner";

/**
 * ProductEnquiryViewV2 Component
 */
const ProductEnquiryViewV2: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [fetchError, setFetchError] = useState<string | null>(null);
  const [enquiry, setEnquiry] = useState<EnquiryDataProps | null>(null);

  const fetchSingleEnquiryData = async () => {
    if (!id) return;
    setEnquiry(null);
    setFetchError(null);
    setIsLoading(true);

    try {
      const resData = await dispatch(fetchProductEnquiryById(id)).unwrap();
      const details = resData.data;
      setEnquiry(details);
    } catch (err: any) {
      console.error("Error fetching product enquiry:", err);
      setFetchError(err?.message || "Failed to fetch product enquiry details.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSingleEnquiryData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id]);

  const handleConvertToQuotation = () => {
    if (enquiry?.id) {
      navigate(`/enquiry/product/create-quotation/${enquiry.id}`);
    }
  };


  return (
    <PageContainer>
      <div className="d-flex align-items-center">
        <ArrowBack
          className="me-2"
          style={{ fontSize: "1.25rem", cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
        <h6 className="card-title mb-0">View Sales Enquiry</h6>
      </div>
      <hr />

      {isLoading ? (
        <LoadingSpinner />
      ) : fetchError || !enquiry ? (
        <div className="p-4">
          <Alert variant={fetchError ? "danger" : "warning"}>
            {fetchError || "No product enquiry data found."}
          </Alert>
          <Button variant="secondary" onClick={() => navigate(-1)}>
            Back to List
          </Button>
        </div>
      ) : (
        <div className="p-1">
          <EnquiryViewComponent
            details={enquiry}
            type="product"
            onConvertToQuotation={handleConvertToQuotation}
          />
        </div>
      )}
    </PageContainer>
  );
};

export default ProductEnquiryViewV2;
